<script setup lang="ts"></script>

<template>
	<ScrollPanel
		class="w-screen h-screen"
		:dt="{
			bar: {
				background: '{primary.950}'
			}
		}"
	>
		<NavBar />
		<router-view />
	</ScrollPanel>
</template>

<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css?family=Ek+Mukta");
@import url("https://fonts.googleapis.com/css?family=Sarabun");
</style>
